import { useEffect, useState } from "react";

const fmt = (tz, d) => d.toLocaleTimeString("en-GB", { timeZone: tz, hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });

export const Clocks = () => {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  return (
    <div data-testid="header-clocks" className="hidden md:flex items-center gap-2 font-num text-[10px] font-semibold">
      <span data-testid="clock-uae" className="rounded-full border border-[var(--line)] bg-white px-2.5 h-7 inline-flex items-center gap-1"><span className="text-[var(--muted-text)]">UAE</span> {fmt("Asia/Dubai", now)}</span>
      <span data-testid="clock-us" className="rounded-full border border-[var(--line)] bg-white px-2.5 h-7 inline-flex items-center gap-1"><span className="text-[var(--muted-text)]">US</span> {fmt("America/New_York", now)}</span>
    </div>
  );
};
